import React, { FC } from 'react';
import classnames from 'classnames';
import { BubbleTheme } from './enums/bubbleTheme.enum';
import { BubbleProps } from './props';
import './styles.scss';

export const Bubble: FC<BubbleProps> = ({ children, className, theme = BubbleTheme.RED }) => {
  return <div className={classnames('left-menu-bubble', `left-menu-bubble--${theme}`, className)}>{children}</div>;
};
